module.exports = {
  footerText: 'Emergency Response Portal © 2020',
}
